import styled from 'styled-components'
const StyledLabel = styled.label`
  input[type='radio'] {
    display: none;
    &:checked + div {
      border-color: var(--primary-color, #11a1c8);
      background: var(--primary-color, #11a1c8);
      box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--primary-color, #11a1c8);
      span {
        display: inline-block;
      }
    }
    
  }
`

const Radio = ({ className, children, ...props }) => {
  return (
    <StyledLabel className={`flex h-full cursor-pointer items-center ${className ? className : ''}`}>
      <input type="radio" {...props} />
      <div className="m-1 w-4 h-4 flex items-center justify-center border rounded-full transition-all duration-200 border-gray-500 bg-white">
        <span className="w-2 h-2 rounded-full transition-all bg-white">
        </span>
      </div>
      {
        children && <span className="ml-2">{children}</span>
      }
    </StyledLabel>
  )
}

export default Radio
